app.controller('SummaryController', [
  '$scope',
  '$location',
  'Services',
  'SessionStorage',
  '$anchorScroll',
  function($scope, $location, $services, SessionStorage, $anchorScroll) {
    $scope.registrationData = SessionStorage.getRegistrationData()
    $scope.isProcessing = false;
    $scope.button=''
    $scope.click0 = true;
    $scope.click1 = true;
    $scope.click2 = true;
    $scope.click3 = true;
    $scope.click4 = true;
    $scope.click5 = true;
    
    $scope.isAgree = false;
    $scope.isAgree1 = false;
    $scope.isAgree2 = false;
    $scope.isAgree3 = false;
    $scope.isAgree4 = false;
    $scope.isAgree5 = false;
    
    $scope.fileId0 = "";
    $scope.fileId1 = "";
    $scope.fileId2 = "";
    $scope.fileId3 = "";
    $scope.fileId4 = "";
    $scope.fileId5 = "";

    $services.getStatementParameters().then(
	  function(res) {
	    if (res.status === 'OK') {
	      setStatement0Text(res.data.statement0.statement0Text)
	      setStatement1Text(res.data.statement1.statement1Text)
	      setStatement2Text(res.data.statement2.statement2Text)
	      setStatement3Text(res.data.statement3.statement3Text)
	      setStatement4Text(res.data.statement4.statement4Text)
	      //Marketing
	      setStatement5Text(res.data.statement5.statement5Text)
	      
	      setStatement0Visible(res.data.statement0.statement0Visible)
	      setStatement1Visible(res.data.statement1.statement1Visible)
	      setStatement2Visible(res.data.statement2.statement2Visible)
	      setStatement3Visible(res.data.statement3.statement3Visible)
	      setStatement4Visible(res.data.statement4.statement4Visible)
	      //Marketing
	      setStatement5Visible(res.data.statement5.statement5Visible)
	      
	      setStatement0Required(res.data.statement0.statement0Required)
	      setStatement1Required(res.data.statement1.statement1Required)
	      setStatement2Required(res.data.statement2.statement2Required)
	      setStatement3Required(res.data.statement3.statement3Required)
	      setStatement4Required(res.data.statement4.statement4Required)
	      //Marketing
	      setStatement5Required(res.data.statement5.statement5Required)
	      
	      setStatement0FileId(res.data.statement0.statement0FileId)
	      setStatement1FileId(res.data.statement1.statement1FileId)
	      setStatement2FileId(res.data.statement2.statement2FileId)
	      setStatement3FileId(res.data.statement3.statement3FileId)
	      setStatement4FileId(res.data.statement4.statement4FileId)
	      //Marketing
	      setStatement5FileId(res.data.statement5.statement5FileId)
	      
	      $scope.registrationData.statement0Title = res.data.statement0.statement0Title
	      $scope.registrationData.statement1Title = res.data.statement1.statement1Title
	      $scope.registrationData.statement2Title = res.data.statement2.statement2Title
	      $scope.registrationData.statement3Title = res.data.statement3.statement3Title
	      $scope.registrationData.statement4Title = res.data.statement4.statement4Title
	      $scope.registrationData.statement5Title = res.data.statement5.statement5Title
	      
	    } else {
	      $scope.errorMessages = res.messages
	    }
	  },
	  function(error) {
	    $scope.errorMessages = ['Ismeretlen hiba.']
	  }
	)
    
    $scope.sayHello = function() {
    	return 'hello';
    };
    
    $scope.next = function() {
    
      console.log('ANGULAR:', $scope.personalDataForm);
      console.log('button:', $scope.personalDataForm.button);
      console.log('DOM:', personalDataForm);
      
      $scope.personalDataForm.button.$setValidity('validationError0', true)
      $scope.personalDataForm.button.$setValidity('validationError1', true)
      $scope.personalDataForm.button.$setValidity('validationError2', true)
      $scope.personalDataForm.button.$setValidity('validationError3', true)
      $scope.personalDataForm.button.$setValidity('validationError4', true)
      $scope.personalDataForm.button.$setValidity('validationError5', true)
    	
      if ($scope.click0 == false && $scope.isAgree) {
          $scope.personalDataForm.button.$setValidity('validationError0', false)
	  } 
      if ($scope.click1 == false && $scope.isAgree1) {
          $scope.personalDataForm.button.$setValidity('validationError1', false)
	  }
      if ($scope.click2 == false && $scope.isAgree2) {
          $scope.personalDataForm.button.$setValidity('validationError2', false)
	  }
      if ($scope.click3 == false && $scope.isAgree3) {
          $scope.personalDataForm.button.$setValidity('validationError3', false)
	  }
      if ($scope.click4 == false && $scope.isAgree4) {
          $scope.personalDataForm.button.$setValidity('validationError4', false)
	  }
      if ($scope.click5 == false && $scope.isAgree5) {
          $scope.personalDataForm.button.$setValidity('validationError5', false)
	  }
    	
      if ($scope.personalDataForm.$valid) {
        $scope.isProcessing = true
        $services.saveClientRegistration(
			$scope.registrationData, $scope.isAgree,
			$scope.isAgree1, $scope.isAgree2, $scope.isAgree3,
			$scope.isAgree4, $scope.isAgree5, $scope.fileId0,
			$scope.fileId1, $scope.fileId2, $scope.fileId3, $scope.fileId4,
			$scope.fileId5)
          .then(
            function(res) {
              if (res.status === 'OK') {
                $location.path('/befejezes')
              } else {
                console.error(res.messages)
                $scope.messages = res.messages
                $scope.isProcessing = false
              }
            },
            function() {
              console.log('Ismeretlen hiba.')
              $scope.isProcessing = false
            }
          )
      }
    }

    $scope.back = function() {
      window.scrollTo(0, 0)
      $location.path('/adatok')
    }
    
    var setStatement0Text = function(mode) {
    	$scope.registrationData.statement0Text = mode
      }
    
    var setStatement1Text = function(mode) {
        $scope.registrationData.statement1Text = mode
      }
    
    var setStatement2Text = function(mode) {
        $scope.registrationData.statement2Text = mode
    }
    
    var setStatement3Text = function(mode) {
        $scope.registrationData.statement3Text = mode
    }
    
    var setStatement4Text = function(mode) {
        $scope.registrationData.statement4Text = mode
    }
    
    var setStatement5Text = function(mode) {
        $scope.registrationData.statement5Text = mode
    }
    
    var setStatement0Required = function(mode) {
        $scope.registrationData.statement0Required = (mode == 'true')
      }
    
    var setStatement1Required = function(mode) {
        $scope.registrationData.statement1Required = (mode == 'true')
      }
    
    var setStatement2Required = function(mode) {
        $scope.registrationData.statement2Required = (mode == 'true')
      } 
    
    var setStatement3Required = function(mode) {
        $scope.registrationData.statement3Required = (mode == 'true')
      }
    
    var setStatement4Required = function(mode) {
        $scope.registrationData.statement4Required = (mode == 'true')
      }
    
    var setStatement5Required = function(mode) {
        $scope.registrationData.statement5Required = (mode == 'true')
      }
    
    var setStatement0Visible = function(mode) {
        $scope.registrationData.statement0Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click0 = false;
        }
      }
    
    var setStatement1Visible = function(mode) {
        $scope.registrationData.statement1Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click1 = false;
        }
      }
    
    var setStatement2Visible = function(mode) {
        $scope.registrationData.statement2Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click2 = false;
        }
    }
    
    var setStatement3Visible = function(mode) {
        $scope.registrationData.statement3Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click3 = false;
        }
    }
    
    var setStatement4Visible = function(mode) {
        $scope.registrationData.statement4Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click4 = false;
        }
    }
    
    var setStatement5Visible = function(mode) {
        $scope.registrationData.statement5Visible = (mode == 'true')
        if(mode == 'true'){
        	$scope.click5 = false;
        }
    }
    
    var setStatement0FileId = function(mode) {
        $scope.registrationData.statement0FileId = mode
        if(mode == '0'){
        	$scope.click0 = true;
        }
      }
    
    var setStatement1FileId = function(mode) {
        $scope.registrationData.statement1FileId = mode
        if(mode == '0'){
        	$scope.click1 = true;
        }
      }
    
    var setStatement2FileId = function(mode) {
        $scope.registrationData.statement2FileId = mode
        if(mode == '0'){
        	$scope.click2 = true;
        }
      }
    
    var setStatement3FileId = function(mode) {
        $scope.registrationData.statement3FileId = mode
        if(mode == '0'){
        	$scope.click3 = true;
        }
      }
    
    var setStatement4FileId = function(mode) {
        $scope.registrationData.statement4FileId = mode
        if(mode == '0'){
        	$scope.click4 = true;
        }
      }
    
    var setStatement5FileId = function(mode) {
        $scope.registrationData.statement5FileId = mode
        if(mode == '0'){
        	$scope.click5 = true;
        }
      }
    
    $scope.verify0 = function(href){
		$scope.click0 = true
		window.open(href, '_blank');
	}
	$scope.verify1 = function(href) {
    	console.log(href)
   	 	$scope.click1 = true
   	 	window.open(href, '_blank');
    }
    
	$scope.verify2 = function(href) {
    	console.log(href)
    	$scope.click2= true
    	window.open(href, '_blank');
    }
    
	$scope.verify3 = function(href) {
    	console.log(href)
    	$scope.click3 = true
    	window.open(href, '_blank');
    }
    
	$scope.verify4 = function(href) {
    	console.log(href)
    	$scope.click4 = true
    	window.open(href, '_blank');
    }
    
	$scope.verify5 = function(href) {
    	console.log(href)
    	$scope.click5 = true
    	window.open(href, '_blank');
    }

	
	
	$scope.getDisabledValue = function() {
		return $scope.isProcessing
				|| ($scope.registrationData.statement0Visible
						&& $scope.registrationData.statement0Required && !$scope.isAgree)
				|| ($scope.registrationData.statement1Visible
						&& $scope.registrationData.statement1Required && !$scope.isAgree1)
				|| ($scope.registrationData.statement2Visible
						&& $scope.registrationData.statement2Required && !$scope.isAgree2)
				|| ($scope.registrationData.statement3Visible
						&& $scope.registrationData.statement3Required && !$scope.isAgree3)
				|| ($scope.registrationData.statement4Visible
						&& $scope.registrationData.statement4Required && !$scope.isAgree4)
				|| ($scope.registrationData.statement5Visible
						&& $scope.registrationData.statement5Required && !$scope.isAgree5);
	}
	
	$scope.check = function(agree, num) {
    	if(num == 0){
			if(agree){
	    		$scope.fileId0 = $scope.registrationData.statement0FileId
	    	}
	    	else{
	    		$scope.fileId0 = "";
	    	}
    	}
    	if(num == 1){
			if(agree){
	    		$scope.fileId1 = $scope.registrationData.statement1FileId
	    	}
	    	else{
	    		$scope.fileId1 = "";
	    	}
    	}
    	if(num == 2){
			if(agree){
	    		$scope.fileId2 = $scope.registrationData.statement2FileId
	    	}
	    	else{
	    		$scope.fileId2 = "";
	    	}
    	}
    	if(num == 3){
			if(agree){
	    		$scope.fileId3 = $scope.registrationData.statement3FileId
	    	}
	    	else{
	    		$scope.fileId3 = "";
	    	}
    	}
    	if(num == 4){
			if(agree){
	    		$scope.fileId4 = $scope.registrationData.statement4FileId
	    	}
	    	else{
	    		$scope.fileId4 = "";
	    	}
    	}
    	if(num == 5){
			if(agree){
	    		$scope.fileId5 = $scope.registrationData.statement5FileId
	    	}
	    	else{
	    		$scope.fileId5 = "";
	    	}
    	}
    }
    
    $scope.uniqueFields = [
    	{ label: $scope.registrationData.labelName1, fieldValue: $scope.registrationData.otherField1, visible: $scope.registrationData.fieldVisible1, type:  $scope.registrationData.fieldType1 },
     	{ label: $scope.registrationData.labelName2, fieldValue: $scope.registrationData.otherField2, visible: $scope.registrationData.fieldVisible2, type:  $scope.registrationData.fieldType2 },
    	{ label: $scope.registrationData.labelName3, fieldValue: $scope.registrationData.otherField3, visible: $scope.registrationData.fieldVisible3, type:  $scope.registrationData.fieldType3  },
     	{ label: $scope.registrationData.labelName4, fieldValue: $scope.registrationData.otherField4, visible: $scope.registrationData.fieldVisible4, type:  $scope.registrationData.fieldType4  },
     	{ label: $scope.registrationData.labelName5, fieldValue: $scope.registrationData.otherField5, visible: $scope.registrationData.fieldVisible5, type:  $scope.registrationData.fieldType5  },
     	{ label: $scope.registrationData.labelName6, fieldValue: $scope.registrationData.otherField6, visible: $scope.registrationData.fieldVisible6, type:  $scope.registrationData.fieldType6  },
     	{ label: $scope.registrationData.labelName7, fieldValue: $scope.registrationData.otherField7, visible: $scope.registrationData.fieldVisible7, type:  $scope.registrationData.fieldType7  },
     	{ label: $scope.registrationData.labelName8, fieldValue: $scope.registrationData.otherField8, visible: $scope.registrationData.fieldVisible8, type:  $scope.registrationData.fieldType8  },
     	{ label: $scope.registrationData.labelName9, fieldValue: $scope.registrationData.otherField9, visible: $scope.registrationData.fieldVisible9, type:  $scope.registrationData.fieldType9  },
     	{ label: $scope.registrationData.labelName10, fieldValue: $scope.registrationData.otherField10, visible: $scope.registrationData.fieldVisible10, type:  $scope.registrationData.fieldType10  },
     	{ label: $scope.registrationData.labelName11, fieldValue: $scope.registrationData.otherField11, visible: $scope.registrationData.fieldVisible11, type:  $scope.registrationData.fieldType11  },
     	{ label: $scope.registrationData.labelName12, fieldValue: $scope.registrationData.otherField12, visible: $scope.registrationData.fieldVisible12, type:  $scope.registrationData.fieldType12  },
     	{ label: $scope.registrationData.labelName13, fieldValue: $scope.registrationData.otherField13, visible: $scope.registrationData.fieldVisible13, type:  $scope.registrationData.fieldType13  },
     	{ label: $scope.registrationData.labelName14, fieldValue: $scope.registrationData.otherField14, visible: $scope.registrationData.fieldVisible14, type:  $scope.registrationData.fieldType14  },
     	{ label: $scope.registrationData.labelName15, fieldValue: $scope.registrationData.otherField15, visible: $scope.registrationData.fieldVisible15, type:  $scope.registrationData.fieldType15  }
      ];
    

    
    $scope.$on('$viewContentLoaded', function(){
    	$location.hash('scrollTo');
        $anchorScroll();
      });
  }
])
